<template>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
          <v-card-title class="primary white--text title">
              Config
          </v-card-title>
          <v-card-text>
              <v-text-field label="Config Name" autofocus v-model="activeItem.config_name"></v-text-field>
              <v-text-field label="Facility Name" autofocus v-model="activeItem.facility_name" disabled></v-text-field>
              <v-text-field label="Config" autofocus v-model="activeItem.config"></v-text-field>

          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord(true)" :disabled="!$can('update', 'Config')">Save</v-btn>
              <v-btn @click="initializeVar(true)">Cancel</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {putConfig} from '../../helper'
  export default {
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.activeItem = this.item
        }
      },
      value () {
        if (!this.activeItem.config_id) {
          this.initializeVar()
        }
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        dialog: false,
        activeItem: {
          config_id: null,
          config_name: '',
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
          config: '',

        } ,

      }
    },
    methods: {
      initializeVar(close) {
        this.activeItem = {
          config_id: null,
          config_name: '',
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
          config: '',

          }
          if(close) {
              this.dialog = false;
          }
      },
      addRecord (close) {
        putConfig(
          {
            'config_id': this.activeItem.config_id,
            'config_name': this.activeItem.config_name,
            'facility_name': this.activeItem.facility_name,
            'config': this.activeItem.config,

          }
        )
          if(close) {
              this.dialog = false;
          }
      }
    },
    name: 'ConfigRecordDialog'
  }
</script>

<style scoped>

</style>
